import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, isMember } from "@/lib/auth";

export const Gate = ({ memberOnly = true }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="pp-app grid place-items-center" data-testid="auth-loading"><Loader2 className="h-8 w-8 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (memberOnly && !isMember(user)) return <Navigate to="/subscribe" replace />;
  if (isMember(user) && localStorage.getItem("pp_join_code")) return <Navigate to="/join" replace />;
  return <Outlet />;
};
